export function parseToData(data, cadastreBuildingFields, cadastreBuildingFieldReferences) {
    if (data.data && data.data.values) {
        cadastreBuildingFields.forEach((field) => {
            if (field.code && data.data.values.hasOwnProperty(field.code)) {
                const fieldValue = data.data.values[field.code];
                if (fieldValue) {
                    if (field.type === 'COMBOBOX' || field.type === 'LISTBOX') {
                        if (fieldValue.id && fieldValue.id > 0) {
                            field.value = fieldValue.id;
                            field.selected = getReferenceById(field.reference.code, fieldValue.id, cadastreBuildingFieldReferences);
                        }
                    } else if (field.type === 'MULTISELECT') {
                        if (fieldValue) {
                            field.selected = [];
                            if (fieldValue.length > 0) {
                                fieldValue.forEach((ref) => {
                                    field.selected.push(ref.id);
                                });
                            } else if (fieldValue.hasOwnProperty('id') && fieldValue.id && fieldValue.id > 0) {
                                field.selected.push(fieldValue.id);
                            }
                            field.value = field.selected;
                        }
                    } else {
                        field.value = fieldValue;
                    }
                }
            }
        });

        return data;
    }
}

function getReferenceById(code, id, cadastreBuildingFieldReferences) {
    if (cadastreBuildingFieldReferences.hasOwnProperty(code)) {
        const fieldReferences = cadastreBuildingFieldReferences[code];
        const references = fieldReferences.filter((ref) => {
            return ref.id === id
        });
        return references.length > 0 ? references[0] : null;
    } else {
        return null;
    }
}
